import { put, call } from 'redux-saga/effects';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* createCoregTemp({ coreg }) {
  try {
    const result = yield call(API.createCoregTemp, coreg);
    if (result.error) {
      yield put({
        type: actionTypes.COREG_TEMP_CREATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.COREG_TEMP_CREATE_SUCCESS,
        coregTemp: result,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.COREG_TEMP_CREATE_ERROR,
      error,
    });
  }
}

export function* createCoreg({ coreg }) {
  try {
    const result = yield call(API.createCoreg, coreg);
    if (result.error) {
      yield put({
        type: actionTypes.COREG_CREATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.COREG_CREATE_SUCCESS,
        coreg: result,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.COREG_CREATE_ERROR,
      error,
    });
  }
}

export function* updateCoreg({ coreg }) {
  try {
    const result = yield call(API.updateCoreg, coreg);
    if (result.id) {
      yield put({
        type: actionTypes.COREG_UPDATE_SUCCESS,
        coreg: result,
      });
    } else {
      yield put({
        type: actionTypes.COREG_UPDATE_ERROR,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.COREG_UPDATE_ERROR,
      error,
    });
  }
}

export function* createCoregFile({ coregFile }) {
  try {
    const result = yield call(API.createCoregFile, coregFile);
    if (result.error) {
      yield put({
        type: actionTypes.COREG_FILE_CREATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.COREG_FILE_CREATE_SUCCESS,
        coregFile: result,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.COREG_FILE_CREATE_ERROR,
      error,
    });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/coreg.js